import React, { useContext } from "react";
import ItemForm from "./ItemForm";
import Image from "../../UI/Image";
import AppContext from "../../../store/app-context";
import AuthContext from "../../../store/auth-context";
import parse from "html-react-parser";

import styles from "./Item.module.css";

const Item = (props) => {
  const appCtx = useContext(AppContext);
  const authCtx = useContext(AuthContext);

  let label_qty = 'Quantity';
  let label_each = 'each';
  let label_addToCart = 'Add to cart';
  let label_instrument = 'Instrument:';
  let label_inquire = 'Inquire';
  let label_login = 'Login';

  if(appCtx && appCtx.bioradResources){
    label_qty = appCtx.bioradResources.Quantity ? appCtx.bioradResources.Quantity : 'Quantity';
    label_each = appCtx.bioradResources.Label_Unit_Measure_Value ? appCtx.bioradResources.Label_Unit_Measure_Value : 'each';
    label_addToCart = appCtx.bioradResources.Add_To_Cart ? appCtx.bioradResources.Add_To_Cart : 'Add to cart';
    label_instrument = appCtx.bioradResources.Instrument ? appCtx.bioradResources.Instrument : 'Instrument:';
    label_inquire = appCtx.bioradResources.Inquire_Price ? appCtx.bioradResources.Inquire_Price : 'Inquire';
    label_login = appCtx.bioradResources.Login ? appCtx.bioradResources.Login : 'Login';
  }

  let skuURL = null;
  if(props?.skuUrl && props.skuUrl !== '') {
    skuURL = appCtx.envProp.webServer + appCtx.lang.toLowerCase() + '-' + appCtx.country.toLowerCase() + '/sku/' + props.skuUrl + '?ID=' + props.sku;
    if(props.skuType==='Bioplex'){
      skuURL = appCtx.envProp.appServer + props.skuUrl;
    }
    if(props.skuUrl.includes('www') || props.skuUrl.includes('http')){
      skuURL = props.skuUrl;
    }
  }

  let imageSrc = props.imageSrc;
  if(imageSrc && !imageSrc.includes('www') && !imageSrc.includes('http')){
    imageSrc = appCtx.envProp.webServer + imageSrc;
  }

  const title = props.title ? parse(props.title) : '';
  const description = props.description ? parse(props.description) : '';

  const webRef = props.webRef
      ? "/" + props.webRef
      : "";

  const loginUrl =
    appCtx.envProp.loginUrl +
    appCtx.envProp.appServer +
    appCtx.envProp.appName +
    webRef +
    "&ui_locales=" +
    appCtx.lang;

  return (
    <li key={props.id} className={styles.item}>
      <div className={styles.productImageinfo}>
        <div className={styles.productImage}>
          <Image imageSrc={imageSrc} />
        </div>
        <div className={styles.productinfo}>
          <h3 className={props?.rebrand ? styles.newTitle :''}>
            {/*props.prodlist ? props.prodlist[props.sku] ? props.prodlist[props.sku].title ? props.prodlist[props.sku].title : "" : "" : ""} #{props.sku}*/}
            {skuURL && <a href={skuURL}>{title} #{props.sku}</a>}
            {!skuURL && <span>{title} #{props.sku}</span>}
          </h3>
          {props.errorMessage && props.errorMessage.length > 0 && (
            <p className={styles.errormsg}>{props.errorMessage}</p>
          )}
          <div className={props?.rebrand ? styles.newDesc : styles.description}>{description}</div>
          <div>
            {props.isEditable && (
              <ItemForm
                id={props.id}
                value={props.quantity}
                onItemChange={props.onItemChange}
                deleteItemHandler={props.deleteItemHandler}
                webRef={props.webRef}
                rebrand={props?.rebrand}
              />
            )}
            {!props.isEditable && (
              <>
                <div className={styles.qnt__price}>
                  <span>
                    <strong>{label_qty}:</strong>{" "}
                  </span>
                  <span>{props.quantity}</span>
                </div>
              </>
            )}
            <div>
              {props.instrument && <span>{label_instrument} {props.instrument}</span>}
            </div>
          </div>
        </div>
      </div>
      <div>
        {props.extendedPrice && props.extendedPrice !== 'Inquire' && (
          <div className={`${props?.rebrand ? styles.newPrice:styles.price}`}>{props.extendedPrice}</div>
        )}
        {props.extendedPrice && props.extendedPrice === 'Inquire' && (
          <div className={`${props?.rebrand ? styles.newPrice:styles.price}`}><span>{label_inquire}</span></div>
        )}
        {props.unitPrice && props.unitPrice !== 'Inquire' && props.unitPrice !== 'Login' && (
          <div className={`${props?.rebrand ? styles.newEachPrice:styles.eachPrice}`}>
            {props.unitPrice}&nbsp;{props.quantity && props.quantity > 1 && <span>{label_each}</span>}
          </div>
        )}
        {props.unitPrice && props.unitPrice === 'Inquire' && (
          <div className={`${props?.rebrand ? styles.newEachPrice:styles.eachPrice}`}>
            <span>{label_inquire}</span>
          </div>
        )}
        {props.unitPrice && props.unitPrice === 'Login' && !authCtx.isLoggedIn && (
          <div className={styles.btnUnderline}>
            <p>
              <a href={loginUrl} className={styles.btnlinkU}>{label_login}</a>
            </p>
        </div>
        )}
      </div>
      {/*<ItemQuantityForm/>
            <ItemPrice/>*/}
    </li>
  );
};

export default Item;
